<template>
  <img
    :src="`imgs/svg/eds/${fileIcon}`"
    :width="`${width}px`"
    :height="`${height}px`"
    class="eds-file-icon"
  />
</template>

<script>
export default {
  props: {
    fileName: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      default: 24
    },
    height: {
      type: Number,
      default: 24
    }
  },
  computed: {
    fileIcon() {
      if (/\.docx?$/.test(this.fileName)) {
        return 'file-icon-doc.svg'
      } else if (/\.xlsx?$/.test(this.fileName)) {
        return 'file-icon-xls.svg'
      } else if (/\.pptx?$/.test(this.fileName)) {
        return 'file-icon-ppt.svg'
      } else if (/\.pdf?$/.test(this.fileName)) {
        return 'file-icon-pdf.svg'
      } else if (/\.txt?$/.test(this.fileName)) {
        return 'file-icon-txt.svg'
      }
      return 'file-icon-default.svg'
    }
  }
}
</script>
